export default __webpack_public_path__ + "095755411fa13c2ae9faca159eb6bd4f.svg";